//
//
//
//
//
//

export default {
    props: ['span', 'float'],
    data () {
        return {

        }
    },
    computed: {
        boxStyle: function() {
            return {
                'width': !!this.span ? this.span + '%' : '100%',
                'float': !!this.float ? this.float : 'left'
            }
        }
    },
    methods: {

    },
    mounted: function() {

    }
}
